export const streamEvents = [
	"ping",
	"connected",
	"disconnected",
	"error",
	"message",
] as const;

export enum StreamReadyState {
	Connecting,
	Open,
	Closed,
}

export type StreamEvent = (typeof streamEvents)[number];
export type Chunk<T> =
	| { value: T; done: false }
	| { value: undefined; done: true }
	| undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- needed for testing on a private property
export type StreamEventHandler<T = any> = (data: T) => void | Promise<void>;
export interface StreamOptions {
	keepAlive?: boolean;
}

export interface Stream<T = unknown> {
	dispose: () => void;
	on: (eventName: StreamEvent, listener: StreamEventHandler<T>) => void;
	off: (eventName: StreamEvent, listener: StreamEventHandler<T>) => void;
	readyState: () => number;
}

export interface AsyncStream<T = unknown> {
	[Symbol.asyncIterator]: () => { next: () => Promise<Chunk<T>> };
	dispose: () => void;
	on: (eventName: StreamEvent, listener: StreamEventHandler<T>) => void;
	off: (eventName: StreamEvent, listener: StreamEventHandler<T>) => void;
}
